import React from 'react';
import { Alert, Box, Typography } from '@tempmee/react';
import { Spinner } from '../../../commonComponents/Spinner';
import { useProfessionalCampaigns } from './hooks';
import { CampaignsTable } from './CampaignsTable';

/**
 * The professional profile's Campaigns tab (GOTU-7054): read-only CS
 * visibility into which campaigns a professional is or has been part of.
 *
 * Professional-only — it is not registered on DNTTabs, which is the office
 * profile.
 */
export const CampaignsTabScreen = () => {
  const {
    professionalId, campaigns, isLoading, isError,
  } = useProfessionalCampaigns();

  // No professional id means the profile is still resolving the user, so the
  // query is disabled and has neither data nor an error. Treated as loading:
  // the empty state here would claim the professional has no campaigns.
  const isPending = isLoading || !professionalId;

  const content = () => {
    if (isPending) {
      return (
        <Box py={6}>
          <Spinner />
        </Box>
      );
    }

    if (isError) {
      return (
        <Alert
          severity="error"
          title="Unable to load campaigns"
          description="The campaign service may be unavailable. Please try again later."
        />
      );
    }

    if (campaigns.length === 0) {
      return (
        <Box py={4}>
          <Typography variant="body1">No campaigns yet.</Typography>
        </Box>
      );
    }

    return <CampaignsTable campaigns={campaigns} />;
  };

  return (
    // width="100%": the profile's tab wrapper is a centring flex column, so
    // without it this Box shrinks to the table's intrinsic width instead of
    // filling the content area as the design shows.
    <Box width="100%" pt={4} px={6}>
      <Box py={10}>
        <Typography variant="h5" as="h2" textAlign="center">
          Campaigns
        </Typography>
      </Box>

      {content()}
    </Box>
  );
};
